import Helpers from '../modules/Helpers'

// Slider thumbnail class (can't currently get this to 'extend')
class SliderThumbNailGallery {

    //#region constructor

        constructor(sliderClass, options, sliderProperties) {

            // Create an accessible instance of the current slider
            this.sliderClass = sliderClass;
            this.slider = sliderClass.slider;
            this.options = options;
            this.sliderProperties = sliderProperties;

            // General properties
            this.thumbnailGalleryId = this.getThumbnailGalleryId(this);
            if(!this.thumbnailGalleryId) return;
            this.thumbnailGallery = document.getElementById(this.thumbnailGalleryId);
            this.thumbnailContainer = this.thumbnailGallery.querySelector('.property-slider__thumbnails');
            this.thumbs = Array.from(this.thumbnailGallery.querySelectorAll('.thumbnail'));
            this.thumbImages = this.thumbnailContainer.querySelectorAll('img');

            // Set slider Thumb General Slider Properties
            this.thumbProperties = this.setThumbProperties();

            // Load up thumbnail fun
            this.thumbnailLoad();

            this.thumbHammer();
        }

    //#endregion
    
    //#region Options Settings/Properties

        // Set all thumb setting properties: this.thumbProperties
        setThumbProperties = () => {
            return {
                clonesOffest: this.thumbs.slice().length,
                clonelessThumbCount: this.thumbs.length,
                currentThumbPosition: 0,
            }
        }

    //#endregion

    //#region Utility Functions

        // Get the containing element id to associate with the slider
        getThumbnailGalleryId = () => this.slider.dataset.thumbnailId;

        // get a cloned version of the thumbnails
        getClonedThumbs = () => this.thumbs.filter(thumb => !thumb.classList.contains('thumb__item--clone')).slice();

        // Update current thumb
        setCurrentThumb = (position) => this.thumbProperties.currentThumbPosition = position;

        // Check if certain thumb is a 'cloned' thumb item
        isThumbAClone = (index) => this.thumbs[index].classList.contains('thumb__item--clone');
            

    //#endregion

    //#region Loading

        // Initial Load Up Of The Slider Thumbnail Gallery
        thumbnailLoad = () => {

            // Add Thumb Clones For Looping
            if (this.sliderProperties.isLoop) this.addThumbClones();
            
            // Update CSS
            this.setThumbActiveCSSClasses(this.thumbProperties.currentThumbPosition, false);

            // Add click events to the thumbs
            this.thumbnailClicks();

            // Add hover events to thumbs
            this.thumbnailHover();

            // Check all the thumbnail images have loaded before we reveal them
            this.checkAllImagesLoaded(() => {

                // Set initial position 
                this.setThumbXAxisPosition(this.thumbProperties.currentThumbPosition, false);

                // Take thumbs out of loading state
                this.setThumbLoadingState(false);

            })

        }

    //#endregion

    //#region utility functions        

        // Set the thumbs in/out of the 'loading' state
        setThumbLoadingState = loading => loading ? this.thumbnailGallery.classList.add('loading') : this.thumbnailGallery.classList.remove('loading');

    //#endregion

    //#region Image Loading

        // Callback function for when all the thumbnail images are loaded
        checkAllImagesLoaded = (callback) => {
            const checkImagesRendered = () => {
                const allImagesRendered = Array.from(this.thumbImages).every(image => image.complete && image.naturalWidth !== 0);
                allImagesRendered ? callback() : requestAnimationFrame(checkImagesRendered);
            };
            checkImagesRendered();
        };
        
    //#endregion

    //#region Set Up Clones

        // Basic entry point for adding clones to slides array and the DOM
        addThumbClones = () => {

            // Clone Last thumb(s) and add them to the front of the slides
            this.addFirstThumbClones();

            // Clone First thumb(s) and add them to the back of the slides
            this.addLastThumbClones();
        }

        // Take the last thumb(s) and clone them before the first thumb array nodes and thumb DOM elements 
        addFirstThumbClones = () => {

            const clones = this.getClonedThumbs();

            clones.reverse().forEach((thumb) => {
                const clonedThumb = thumb.cloneNode(true);
                // Add clone specific class
                new Helpers(clonedThumb).addClass('thumb__item--clone');
                // Add clone to global thumb array
                this.thumbs.unshift(clonedThumb);
                // Add to the DOM
                this.thumbnailContainer.prepend(clonedThumb);
            });

            // Adjust for inserted clones
            this.setCurrentThumb(clones.length);

        };

        // Take the first thumb(s) and clone them after the last thumb array nodes and thumb DOM elements 
        addLastThumbClones = () => {

            this.getClonedThumbs().forEach(thumb => {
                const clonedThumb = thumb.cloneNode(true);
                // Add clone specific class
                new Helpers(clonedThumb).addClass('thumb__item--clone');
                // Append clone to global thumb array 
                this.thumbs.push(clonedThumb);
                // Append clone to the DOM
                this.thumbnailContainer.append(clonedThumb);
            });
        };



    //#endregion

    //#region Position change and associated Functions

        // Previous thumb
        previousThumb = () => this.nextPrevFunctions(this.thumbProperties.currentThumbPosition-1);

        // Next thumb
        nextThumb = () => this.nextPrevFunctions(this.thumbProperties.currentThumbPosition+1);

        // shared functionality for moving to prev/next thumb
        nextPrevFunctions = (newPostiton) => {

            // set global property
            this.setCurrentThumb(newPostiton);

            // Change thumb
            this.setThumbXAxisPosition(newPostiton, true);

            // Update CSS
            this.setThumbActiveCSSClasses(newPostiton, true);

            // Check if loop is required
            this.loopThumbs(newPostiton);
        }

        // Change where the thumb is
        changeActiveThumb = (newPostiton, useTransition = true) => {

            // set global property
            this.setCurrentThumb(newPostiton);

            // Trigger the DOM change
            this.setThumbXAxisPosition(newPostiton, useTransition);

            // Update CSS
            this.setThumbActiveCSSClasses(newPostiton, useTransition);

            // Check if loop is required
            this.loopThumbs(newPostiton);

        }

        // Set thumb position
        setThumbXAxisPosition = (thumbIndex, useTransition = true) => {
            let position = 0;
            let sliced = this.thumbs.slice(0, thumbIndex);
            sliced.forEach(thumb => {
                const rect = thumb.getBoundingClientRect();
                position += rect.width;
            });

            // If thumb is gracefully 'sliding' to new position or jumping (Jump to, probably part of a 'loop')
            if (useTransition) {
                this.thumbnailContainer.style.transition = `transform ${this.options.speed}s ease-in-out 0s`;
            } else {
                this.thumbnailContainer.style.transition = 'none';
            }

            // Move thumb into position
            if (this.sliderProperties.isBrowserIE9) {
                this.thumbnailContainer.style.msTransform = `translateX(-${position}px)`
            } else {
                this.thumbnailContainer.style.transform = `translate3d(-${position}px, 0px, 0px)`
                this.thumbnailContainer.style.webkitTransform = `translateX(-${position}px)`
            }

        }

        // Set thumb as active via class
        // Note: we use 'active--no-transition' to avoid buggy double transitions while looping the thumb
        setThumbActiveCSSClasses = (position, useTransition = true) => {
            this.thumbs.forEach(x => x.classList.remove('active', 'active--no-transition'));
            useTransition ? this.thumbs[position].classList.add('active') : this.thumbs[position].classList.add('active--no-transition');
        }

    //#endregion

    //#region Thumb loop functions

        // Check and then loop the thumbs if need be
        loopThumbs = (newThumbPosition) => {
            
            const offset = this.thumbProperties.clonesOffest;

            if (this.isThumbAClone(newThumbPosition)) {
                if (newThumbPosition < offset) {
                    let adjustedNewPosition = newThumbPosition + (this.thumbs.length - (offset * 2));
                    this.doThumbBackLoop(adjustedNewPosition);
                }
                else if (newThumbPosition >= this.thumbs.length - offset) {
                    let adjustedNewPosition = newThumbPosition - (this.thumbs.length - offset) + offset;
                    this.doThumbFrontLoop(adjustedNewPosition);
                }
            }
        }


        // Loop back over images (so from the first thumb to the last)
        doThumbBackLoop = (newThumbPosition) => {
            setTimeout(() => {
                this.loopThumbFunctions(newThumbPosition);
            }, this.options.speed * 1000);
        }


        // Loop back over images (so from the first slider to the last)
        doThumbFrontLoop = (newThumbPosition) => {
            setTimeout(() => {
                this.loopThumbFunctions(newThumbPosition);
            }, this.options.speed * 1000);
        }


        // Shared loop functionality regardless of front or back loop 
        loopThumbFunctions = (newThumbPosition) => {

            // Trigger the DOM change
            this.setThumbXAxisPosition(newThumbPosition, false);

            // // Update CSS
            this.setThumbActiveCSSClasses(newThumbPosition, false);

            // // Update global position
            this.setCurrentThumb(newThumbPosition);
        }


    //#endregion

    //#region Thumbnail clicks

        // Add click events for the thumbnail gallery
        thumbnailClicks = () => {

            // Loop through each thumbnail
            this.thumbs.forEach((thumb, thumbIndex) => {

                // Add click event listener to each thumbnail
                thumb.addEventListener('click', () => {

                    // Get the index of the clicked thumbnail
                    const dataIndex = parseInt(thumb.dataset.sliderIndex, 10);
                    const currentSlideDataIndex = parseInt(this.sliderClass.slides[this.sliderProperties.currentSliderPosition].dataset.sliderIndex, 10);
                    if(dataIndex !== currentSlideDataIndex)
                    {
                        // Adjust index to target to prevent 'whirling' visual bug 
                        const newSlidePosition = this.PreventWhirlingEffect(dataIndex);

                        // Change slider position to the clicked index
                        this.sliderClass.changeActiveSlider(newSlidePosition);

                        // Change thumb
                        this.changeActiveThumb(thumbIndex, true);
                    }
                });
            });
        }

        // Adjust index of selected to next clone rather than actual slide if that would cause a whirling visual bug
        PreventWhirlingEffect = (dataIndex) => {
        
            const sliderLength = this.sliderClass.slides.length;
            let currentIndex = this.sliderProperties.currentSliderPosition;
            let nextIndex = (currentIndex + 1) % sliderLength;
            
            // Check if current index is less than or equal to half of the total slides
            if (currentIndex >= sliderLength / 2) {
                // Search forward (will be a clone)
               for (let i = nextIndex; i !== currentIndex; i = (i + 1) % sliderLength) { 
                   if (this.sliderClass.slides[i].getAttribute('data-slider-index') === dataIndex.toString()) {
                       return i;
                   }
               }
            } 

            // Return dataIndex corrected with clone offset 
            return dataIndex + this.sliderClass.options.clonesOffset;
        }
        

    //#endregion

    //#region Thumbnail hover
        
        // Add hover event to thumbs (mainly to predict and pre-load images)
        thumbnailHover = () => {

            // Iterate through each element in the array
            this.thumbs.forEach((thumb) => {
                // Add a hover event listener to each element
                thumb.addEventListener('mouseover', () => {
                    // Get the hovered element's data-slider-index attribute value
                    const hoveredIndex = parseInt(thumb.getAttribute('data-slider-index'));
                    
                    // Create an array of indices from 0 to the hovered index
                    const indices = Array.from({ length: hoveredIndex + this.options.clonesOffset }, (_, i) => i);
                    
                    // Load the array of indices
                    this.sliderClass.lazyLoadSlideImages(indices, true, true);
                });
            });
        }

    //#endregion

        //#endregion hammer / swipe gesture

        thumbHammer = () => {
            if (typeof Hammer === 'function') {

                const thumbHammertime = new Hammer(this.thumbnailGallery);

                thumbHammertime.on('panright', () => {
                    this.hammerDirection = 'prev';
                });

                thumbHammertime.on('panleft', () => {
                    this.hammerDirection = 'next';
                });

                thumbHammertime.on('panend', () => {

                    let newSliderPosition = this.hammerDirection === 'next' ? ++this.sliderProperties.currentSliderPosition : --this.sliderProperties.currentSliderPosition;

                    // Update slider
                    this.sliderClass.changeActiveSlider(newSliderPosition);

                    /// Update thumbs
                    if(this.hammerDirection === 'next')
                        this.nextThumb();
                    else
                        this.previousThumb();
                    
                    clearInterval(this.autoInt);
                });
            }
        }

    //#endregion

}

export default SliderThumbNailGallery;